WL.IncomeSourceRepeater = new Class({

    Extends: TS.domain.RepeaterEditDomain,

    createProperties: function (config) {
        var me = this;
         
        me.parent(config);

        var incomeSourceDetailList = me.getDomainProperty('PartnerIncomeSourceDetailProperty');

        if (incomeSourceDetailList != null) {
            incomeSourceDetailList.on('cellBeginEdit', me.onIncomeSourceDetailEdit);
            incomeSourceDetailList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    var cols = e.sender.columns;
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        var dcellMY = row.children().eq(2);
                        var dcellY = row.children().eq(3);
                        var dcellD = row.children().eq(1);
                         
                        if (dataItem.PeriodTypeCode == 'MONTHYEAR') {
                            dcellY.attr("style", "display:none");
                            dcellD.attr("style", "display:none");
                        }

                        if (dataItem.PeriodTypeCode == 'YEAR') { 
                            dcellMY.attr("style", "display:none");
                            dcellD.attr("style", "display:none"); 
                        }

                        if (dataItem.PeriodTypeCode == 'DATE' || dataItem.PeriodTypeCode == null) {
                            dcellY.attr("style", "display:none");
                            dcellMY.attr("style", "display:none");
                        }    

                        if (dataItem.IsReadOnly == true)
                        {
                            row.addClass("grey_readonly_scoring_category");
                        }
                    }

                    for (var j = 0; j < e.sender._headerCells().length; j++) {
                        if (e.sender._headerCells()[j].dataset.title === 'Period2' || e.sender._headerCells()[j].dataset.title === 'Period3')
                            e.sender._headerCells()[j].hidden = true;
                    }
                }
            }
        }
    },
     
    onIncomeSourceDetailEdit: function (e) {
        var me = this,
            rec = e.item,
            owner = me._getOwner(),
            incomeSourceDetailList = owner.getDomainProperty('PartnerIncomeSourceDetailProperty');

        if (e.fieldName == 'PropertyValueDynamic' || e.fieldName == 'Period') {
            if (incomeSourceDetailList.SelectedItem().IsReadOnly())
            e.preventDefault();
        }
    }
});